module.exports = __webpack_public_path__ + "57c7199f400fb1a5f049d33f6fae65bd.svg";